// src/index.js
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { installEmbedHandshake } from "./handshake";
import { bootstrapOrgCookie, ping } from "./services/api";

installEmbedHandshake();

function DevBootstrap() {
  useEffect(() => {
    (async () => {
      try {
        const url = new URL(window.location.href);
        const orgId = url.searchParams.get("orgId");
        const token = url.searchParams.get("token");

        // Show what's happening in the console for debugging
        console.log("[careers] DevBootstrap: url =", url.toString());
        console.log("[careers] DevBootstrap: orgId =", orgId, "token present =", !!token);

        if (orgId && token) {
          console.log("[careers] DevBootstrap: calling /api/careers/auth (dev only)...");
          await bootstrapOrgCookie({ orgId, token });
          console.log("[careers] DevBootstrap: /auth done, now pinging...");

          // Confirm cookie works
          await ping();
          console.log("[careers] DevBootstrap: ping ok, cleaning URL...");

          // Clean URL only AFTER ping succeeded
          url.searchParams.delete("orgId");
          url.searchParams.delete("token");
          window.history.replaceState({}, "", url.toString());
        } else {
          // No orgId/token in URL — just try ping to see if there's already a cookie
          await ping();
          console.log("[careers] DevBootstrap: ping ok (cookie already present)");
        }
      } catch (e) {
        console.warn("[careers] DevBootstrap: bootstrap/ping failed:", e?.message || e);
      }
    })();
  }, []);

  return null;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <DevBootstrap />
    <App />
  </BrowserRouter>
);
